module.exports = __webpack_public_path__ + "static/Awards&Recognition_banner@2x-43d81a98bf2bf6e47b61598acab6bd7d.png";